import React, { useState, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import styles from "./EagleTrackerProfile.module.css";
import QualifyHeader from "../../components/QualifyHeader";
import SettingsModal from "../../components/SettingsModal";
import Qualifications from "./imgs/Qualifications.png";
import Close from "./imgs/Close_Button.svg";
import EagleProfileHeader from "../../components/EagleProfileHeader";
import TagMonster from "../../components/TagMonster";
import { EagleItem } from "../../components/EagleItem/EagleItem";
import Loader from "components/Loader";

import { useEagleTrackerProfile } from "./useEagleTrackerProfile";
import { useTranslation } from "react-i18next";

export const EagleTrackerProfile = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const { state } = useLocation();

  const { ibo, event, year } = state;

  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState("Bonus Legs");
  const [qualOpened, setQualOpened] = useState(false);
  const [eagleData, setEagleData] = useState(null);

  const onSave = () => setOpened(false);

  const { data, isLoading, refetch } = useEagleTrackerProfile({
    ibo,
    event,
    year,
  });

  useEffect(() => {
    if (data) {
      setEagleData(data);
    }
  }, [data]);

  useEffect(() => {
    if (ibo && event && year) {
      setEagleData(null);
      refetch({ ibo, event, year });
    }
  }, [ibo, event, year, refetch]);

  const getStatProps = (leg) => {
    if (selected === "Bonus Legs") {
      return {
        bonusLevelPercentage: leg.bonusLevelPercentage,
      };
    }
    if (selected === "PM + DD Legs") {
      return {
        pmLegs: leg.pmLegs,
      };
    }
    if (selected === "Function Legs") {
      return {
        majorFunctions: leg.majorFunctions,
      };
    }
    return {};
  };

  const filteredLegs = useMemo(() => {
    if (!eagleData) return [];
    return eagleData.legsReceivingBonus.filter((leg) => {
      if (selected === "Bonus Legs") {
        return leg.bonusLevelPercentage?.value != null;
      }
      if (selected === "PM + DD Legs") {
        return leg.pmLegs?.value != null;
      }
      if (selected === "Function Legs") {
        return leg.majorFunctions;
      }
      return true;
    });
  }, [eagleData, selected]);

  if (isLoading || !eagleData) {
    return (
      <div className={styles.loaderContainer}>
        <Loader color="#22252e" />
      </div>
    );
  }

  return (
    <div className={qualOpened ? styles.qualContainer : styles.container}>
      {!qualOpened && (
        <div>
          <SettingsModal
            isOpen={opened}
            onCancel={() => setOpened(false)}
            onSave={onSave}
          />
          <QualifyHeader onClick={() => setQualOpened(true)} />
          <div className={styles.divider} />
          <EagleProfileHeader
            name={eagleData.iboInfo.iboName}
            lastName=""
            avatar={[
              eagleData.iboInfo.iboAAvatar,
              eagleData.iboInfo.iboBAvatar,
            ].filter(Boolean)}
            onBack={() => history.push("/eagle-tracker")}
          />
          <div className={styles.tmWrapper}>
            <TagMonster
              categories={[
                { title: "Bonus Legs", rowNumber: 1 },
                { title: "PM + DD Legs", rowNumber: 1 },
                { title: "Function Legs", rowNumber: 1 },
              ]}
              selectedCategory={selected}
              onClick={setSelected}
            />
          </div>
          <div className={styles.listHeader}>
            {selected === t("PM + DD Legs")
              ? t("Legs on PM + DD")
              : selected?.title === t("Function Legs")
              ? t("Legs with Function Tickets")
              : t("Legs Receiving Bonus")}
          </div>

          {filteredLegs.map((leg) => (
            <div className={styles.eagleContainer}>
              <EagleItem
                key={leg.ibo}
                name={leg.iboName}
                avatar={[leg.iboAAvatar, leg.iboBAvatar].filter(Boolean)}
                onClick={() => {}}
                {...getStatProps(leg)}
              />
            </div>
          ))}
        </div>
      )}

      {qualOpened && (
        <div className={styles.qual}>
          <div className={styles.close} onClick={() => setQualOpened(false)}>
            <img src={Close} alt="Close" />
          </div>
          <div>
            <img className={styles.qualsvg} src={Qualifications} alt="Quals" />
          </div>
        </div>
      )}
    </div>
  );
};
